/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Empty_SetsInputs */



/**
* | output |
* | --- |
* | "Please create a new set to start" |
*
* @param {Tags_Manager_Empty_SetsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_empty_sets = /** @type {((inputs?: Tags_Manager_Empty_SetsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Empty_SetsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Veuillez creer un nouvel ensemble pour commencer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte erstellen Sie ein neues Set, um zu beginnen.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Per iniziare, crea un nuovo set")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Пожалуйста, создайте новый набор для начала.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Por favor crea un nuevo conjunto para comenzar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("请创建一个新数据集以开始")
	if (locale === "ja") return /** @type {LocalizedString} */ ("開始するには新しいセットを作成してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कृपया शुरुआत करने के लिए एक नया सेट बनाएं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Por favor, crie um novo conjunto para começar.")
	return /** @type {LocalizedString} */ ("Please create a new set to start")
});